'use client'

import type { ReactNode } from 'react'

import cn from '@config/tailwind/cn'

import { poppins } from '~/font'
import { AuthModalsProvider, SiteFooter, SiteNav } from '~/lib/landing'
import { StickyBanner } from '~/lib/sticky-banner'

export function MainLayoutClient({ children }: { children: ReactNode }) {
  return (
    <AuthModalsProvider>
      <div className='relative h-fit min-h-dvh w-full overflow-x-clip'>
        <StickyBanner className={cn('h-[5dvh] max-h-[5dvh] min-h-[5dvh]', poppins.className)} />

        <SiteNav className='sticky top-0' />

        {children}

        <SiteFooter />
      </div>
    </AuthModalsProvider>
  )
}
